import { createTheme } from '@mui/material';

export const FONT_WEIGHT_NORMAL = 400;
export const FONT_WEIGHT_SEMI_BOLD = 600;
export const FONT_WEIGHT_BOLD = 700;

export const FONT_SIZE_61_PX = '3.8125rem';
export const FONT_SIZE_49_PX = '3.0625rem';
export const FONT_SIZE_45_PX = '2.8125rem';
export const FONT_SIZE_39_PX = '2.4375rem';
export const FONT_SIZE_31_PX = '1.938rem';
export const FONT_SIZE_16_PX = '1rem';
export const FONT_SIZE_13_PX = '0.8125rem';
export const FONT_SIZE_10_PX = '0.625rem';

export const COLOR_CHATHAMS_BLUE = '#124D80';
export const COLOR_DOWN_RIVER = '#0B2E4D';
export const COLOR_DENIM = '#196DB6';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_RED = '#FF0000';
export const COLOR_BLACK_HAZE = '#F9FAFA';
export const COLOR_REGENT_ST_BLUE = '#9CC0E0';
export const COLOR_HUMMINGBIRD = '#D8F2F9';
export const COLOR_GALLERY = '#EDEDED';
export const COLOR_DISABLED_BG = COLOR_GALLERY;
export const COLOR_DISABLED_TEXT = COLOR_DENIM;
export const COLOR_PALE_SKY = '#67747F';
export const COLOR_GREEN = '#008000';
export const COLOR_SUMMER_SKY = '#33B1FA';
export const COLOR_LIGHT_GREY = '#CCCCCC';
export const COLOR_CARNATION = '#F54F5E';
export const COLOR_SAIL = '#9BDEF5';
export const COLOR_BLACK_PERL = '#061B2E';
export const COLOR_SALMON = '#FF8E72';
export const COLOR_GOLDEN_TAINOI = '#FFCD69';
export const COLOR_KOBI = '#EEA7CE';
export const COLOR_MONTE_CARLO = '#87C9B5';
export const COLOR_CERULIAN = '#26B6E0';
export const COLOR_SILVER = '#C0C0C0';

export const popTheme = ({ mode }) =>
  createTheme({
    palette: {
      ...(mode === 'light'
        ? {
            // palette values for light mode
            primary: {
              main: COLOR_DENIM,
            },
            background: {
              default: COLOR_BLACK_HAZE,
            },
            text: {
              primary: COLOR_CHATHAMS_BLUE,
              secondary: COLOR_DENIM,
              tertiary: COLOR_PALE_SKY,
            },
            title: {
              main: COLOR_WHITE,
            },
          }
        : {
            // palette values for dark mode
            primary: {
              main: COLOR_CERULIAN,
            },
            background: {
              default: COLOR_BLACK_PERL,
            },
            text: {
              primary: COLOR_CERULIAN,
              secondary: COLOR_CERULIAN,
              tertiary: COLOR_BLACK_HAZE,
            },
            title: {
              main: COLOR_CERULIAN,
            },
          }),
    },
    typography: {
      fontSize: 16,
      h1: {
        fontSize: FONT_SIZE_49_PX,
        fontWeight: FONT_WEIGHT_BOLD,
      },
      h2: {
        fontSize: FONT_SIZE_39_PX,
        fontWeight: FONT_WEIGHT_BOLD,
      },
      h3: {
        fontSize: FONT_SIZE_31_PX,
        fontWeight: FONT_WEIGHT_BOLD,
      },
      h4: {
        fontSize: '1.562rem',
        fontWeight: FONT_WEIGHT_BOLD,
      },
      h5: {
        fontSize: '1.25rem',
        fontWeight: FONT_WEIGHT_BOLD,
      },
      h6: {
        fontSize: FONT_SIZE_16_PX,
        fontWeight: FONT_WEIGHT_BOLD,
      },
      subtitle1: {
        // Equivalent to body sm in the figma
        fontSize: FONT_SIZE_13_PX,
      },
      subtitle2: {},
      body1: {
        // Equivalent to body in the figma
        fontSize: '1rem',
      },
      body2: {
        // Equivalent to body lg in the figma
        fontSize: '1.25rem',
      },
      caption: {},
      overline: {},
      button: {
        textTransform: 'none',
      },
    },
    mixins: {
      toolbar: {
        minHeight: '120px',
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          // The props to change the default for.
          disableRipple: true, // No more ripple, on the whole application 💣!
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            // Set input autofill background color same as the Textfield color
            '&:-webkit-autofill': {
              WebkitBoxShadow: '0 0 0 100px #F9FAFA inset',
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            '&.Mui-error': {
              color: COLOR_WHITE,
              alignSelf: 'center',
            },
          },
        },
      },
      MuiLink: {
        variants: [
          {
            props: { variant: 'body1' },
            style: {
              color: COLOR_DENIM,
            },
          },
        ],
      },
      MuiButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
          contained: {
            '&:hover': {
              backgroundColor: mode === 'light' ? COLOR_SILVER : COLOR_BLACK_HAZE,
            },
          },
        },
      },
    },
  });
